import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const createCallBooking = (data) => axios.post(`${API}/call-bookings`, data).then((r) => r.data);

// Public content reads
export const getSettings = () => axios.get(`${API}/content/settings`).then((r) => r.data);
export const getTestimonials = () => axios.get(`${API}/content/testimonials`).then((r) => r.data);
export const getEventThemes = () => axios.get(`${API}/content/event-themes`).then((r) => r.data);
export const getPress = () => axios.get(`${API}/content/press`).then((r) => r.data);

export default API;
